// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SearchInputWrapper_wrapper__2Slgc"};